module.exports = __webpack_public_path__ + "img/pending.a1478d4d.png";